const iconUrl = 'https://d2nl2ito1t68bd.cloudfront.net/static/global/antero-pin.svg';

const svgPathToImage = ({ path, width, height }) => new Promise(resolve => {
  const image = new Image(width, height);
  image.addEventListener('load', () => resolve(image));
  image.src = path;
});

function createMarkerPin() {
  const el = document.createElement('div');
  el.className = 'marker';
  Object.assign(el.style, {
    backgroundImage: `url(${iconUrl})`,
    backgroundSize: 'contain',
    width: '4rem',
    height: '4rem',
    transformOrigin: 'bottom',
    transition: 'transform 200ms cubic-bezier(0.34, 1.56, 0.64, 1)',
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
  });
  return el;
}

export {
  iconUrl,
  svgPathToImage,
  createMarkerPin,
};
